// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * # Keyboard Help Panel Styles
 *
 * Styling for the keyboard shortcuts panel in the IDE sidebar.
 * Uses IDE CSS variables for consistency with the rest of the app.
 */

/* Two-column grid for shortcut rows within a category */
.kb-panel-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px 12px;
  padding: 0 4px;
}

/* Single shortcut row: key badge + description */
.kb-panel-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 2px;
}

/* Key badge: styled pill */
.kb-panel-key {
  display: inline-block;
  min-width: 32px;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  font-family: "Courier New", monospace;
  color: var(--color-ide-text);
  background: var(--color-ide-surface-2);
  border: 1px solid var(--color-ide-border);
  border-radius: 3px;
  padding: 1px 5px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Description text */
.kb-panel-desc {
  font-size: 11px;
  color: var(--color-ide-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Category header */
.kb-panel-category {
  font-size: 10px;
  font-weight: 600;
  text-transform: capitalize;
  color: var(--color-ide-text-dim);
  padding: 6px 6px 2px;
  letter-spacing: 0.3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/KeyboardHelpPanel/keyboardHelpPanel.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,wDAAwD;AACxD;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;AACvB","sourcesContent":["/*\n * # Keyboard Help Panel Styles\n *\n * Styling for the keyboard shortcuts panel in the IDE sidebar.\n * Uses IDE CSS variables for consistency with the rest of the app.\n */\n\n/* Two-column grid for shortcut rows within a category */\n.kb-panel-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1px 12px;\n  padding: 0 4px;\n}\n\n/* Single shortcut row: key badge + description */\n.kb-panel-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 2px;\n}\n\n/* Key badge: styled pill */\n.kb-panel-key {\n  display: inline-block;\n  min-width: 32px;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 600;\n  font-family: \"Courier New\", monospace;\n  color: var(--color-ide-text);\n  background: var(--color-ide-surface-2);\n  border: 1px solid var(--color-ide-border);\n  border-radius: 3px;\n  padding: 1px 5px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Description text */\n.kb-panel-desc {\n  font-size: 11px;\n  color: var(--color-ide-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Category header */\n.kb-panel-category {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: capitalize;\n  color: var(--color-ide-text-dim);\n  padding: 6px 6px 2px;\n  letter-spacing: 0.3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
